import { render } from "./SoftwaresEdit.vue?vue&type=template&id=673d3279"
import script from "./SoftwaresEdit.vue?vue&type=script&lang=js"
export * from "./SoftwaresEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__